import Vue from 'vue'
import 'ag-grid-enterprise'
import {LicenseManager} from "ag-grid-enterprise"
import {AgGridVue} from 'ag-grid-vue'

LicenseManager.setLicenseKey("Kaam_Innovacion_certiapp_1Devs26_September_2020__MTYwMTA3NDgwMDAwMA==3aee2d6731abce7ca7e01101e34c8a7b")
Vue.component('ag-grid-vue', AgGridVue)
